import { ProjectChapter } from '../../../interfaces/project';
import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { ReduxService } from './../../../services/redux.service';
import { Subscription } from 'rxjs';
import { ProjectFlowchartState } from '../../../shared/redux/project-flowchart.store';
import { FlowchartStep } from './../../../shared/models/flowchart-step.model';


@Component({
	selector: 'flowchart-columns',
	templateUrl: './flowchart-columns.component.html',
	styleUrls: ['./flowchart-columns.component.scss']
})
export class FlowchartColumnsComponent implements OnChanges, OnDestroy {
	// @Input() chapters: ProjectChapter[];
	@Input() zoom: number;
	@Input() highlight: any[];
	@Input() allowEdit: boolean;

	chapters: ProjectChapter[];
	steps: FlowchartStep;
	editMode: any = {};
	showEditIcon: any = {};
	emptyChapters: any[];
	private stateSubscription: Subscription;

	constructor(
		protected reduxService: ReduxService
	) {
		this.stateSubscription = this.reduxService.stateObs.subscribe((state: ProjectFlowchartState) => {
			if (state && state.data && state.data.chapters) {
				this.chapters = this.copyChapters(state.data.chapters);
			}
			if (state && state.data && state.data.steps) {
				this.steps = (state.data.steps);
			}
		});
	}

	ngOnChanges() {
		if (!this.steps) {
			return;
		}
		const chapterIdsFromStep = Object.keys(this.steps).map(key => this.steps[key].chapterId);
		if (!this.chapters) {
			return;
		}
		const chapterIdsFromChapter = Object.keys(this.chapters).map(key => this.chapters[key].id);
		const filterChapters1 = chapterIdsFromStep.filter((i) => chapterIdsFromChapter.indexOf(i) === -1);
		const filterChapters2 = chapterIdsFromChapter.filter((i) => chapterIdsFromStep.indexOf(i) === -1);
		this.emptyChapters = filterChapters1.concat(filterChapters2);
	}

	ngOnDestroy() {
		this.stateSubscription.unsubscribe();
	}

	editChapter(i: number) {
		// Make only one title editable at the same time:
		Object.keys(this.editMode)
			.filter(k => this.editMode[k] !== this.editMode[i])
			.forEach(k => this.editMode[k] = false);
		this.editMode[i] = true;
	}

	updateChapter(i: number) {
		this.editMode[i] = false;
		const changedChapter = { ...this.chapters[i] };

		this.reduxService.dispatch({ type: 'UPDATE_CHAPTER', chapterIndex: i, chapter: changedChapter });
	}

	copyChapters(updatedChapters: ProjectChapter[]) {
		const newChapters = [...updatedChapters];
		updatedChapters.forEach((updatedChapter, i) => {
			newChapters[i] = { ...updatedChapter };
		});
		return newChapters;
	}

	deleteChapter(ev: MouseEvent, i: number) {
		ev.stopPropagation();

		const changedChapter = { ...this.chapters[i] };
		this.reduxService.dispatch({ type: 'DELETE_CHAPTER', chapterIndex: i, chapter: changedChapter });
	}
}
